<template>
  <div id="totalBox">
    <div class="businessBox">
      <p class="businessTitle">车场业态</p>
      <p class="businessTip">以车场服务为主，打造停车生态链，实现多元化商业模式</p>
      <div class="businessList">
        <div class="businessListContent">
          <img src="../../assets/home/washCar.png" class="businessImg" alt="" />
          <p class="businessName">无人洗车</p>
        </div>
        <div class="businessListContent">
          <img src="../../assets/home/sale.png" class="businessImg" alt="" />
          <p class="businessName">无人零售</p>
        </div>
        <div class="businessListContent">
          <img src="../../assets/home/shareCar.png" class="businessImg" alt="" />
          <p class="businessName">共享汽车</p>
        </div>
        <div class="businessListContent">
          <img src="../../assets/home/charge.png" class="businessImg" alt="" />
          <p class="businessName">智能充电桩</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Business',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
}
.businessBox{
  padding-top: 70px;
  width: 1200px;
  margin: 0 auto;
}
.businessTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(19,19,19,1);
  padding-left: 93px;
  text-align: left;
}
.businessTip{
  padding-left: 93px;
  text-align: left;
  font-size:20px;
  font-weight:400;
  color:rgba(19,19,19,1);
  margin-top: 22px;
}
.businessList{
  width: 100%;
  height:380px;
  background:rgba(255,255,255,1);
  box-shadow:0px 4px 30px 0px rgba(35,33,33,0.3);
  margin-top: 37px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 67px;
}

.businessImg{
  width: 180px;
  height: 180px;
}
.businessName{
  font-size:24px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(19,19,19,1);
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/business.vue